import React from "react";
import {injectIntl} from "react-intl";
import MsFeedbackMessage from "./widgets/ms-feedback-message.jsx";
import MsVideoPlayer from "./player/ms-video-player.jsx";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.jsonPayload = null;
    if (this.props.data && this.props.id != "") {
      let dataSplit = this.props.data.split("::");
      let external_stream_info;
      if(dataSplit[6]){
        external_stream_info= JSON.parse(window.atob(dataSplit[6]));
      }else{
        external_stream_info=null;
      }

      this.jsonPayload = {
        pingId: this.props.id,
        stream: window.atob(dataSplit[1]),
        app: window.atob(dataSplit[2]),
        goLive: dataSplit[0],
        timeZone: this.props.timeZone,
        type: dataSplit[3],
        streamTitle: this.props.streamName,
        vm_wsh: dataSplit[4],
        externally_managed:external_stream_info?.externally_managed ?? false,
        external_access_code_page:external_stream_info?.external_access_code_page ?? false,
        source: this.props.streamSource,
      }
    }
  }

  render() {
    return (
      <div id="app-container">
        { !this.jsonPayload ?
          <MsFeedbackMessage
            title="Stream currently unavailable"
            message="The requested stream is switched off or embedded code is invalid."
            wclass="unavailable"
            subTitle={null}
            bottomComponent={null}
          />
          :
          <MsVideoPlayer
            jsonPayload={this.jsonPayload}
            hash={this.props.hash}
            width={this.props.width}
            height={this.props.height}
            embedded={this.props.embedded}
            hasChat={this.props.hasChat}
            chatMobileClass={this.props.chatMobileClass}
            serverAddress={this.props.serverAddress}
            serverSecure={this.props.serverSecure}
          />
        }
      </div>
    );
  }
}
export default injectIntl(App);
